import { SubSink } from 'subsink';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';

import { StateType } from '@monorepo/ui';

import { LoadingType } from '@monorepo/ui';
import { ALOGLIA_CONFIG } from '../../../shared/constants';

enum PageState {
  LOADING,
  LOADED,
  NO_LISTING,
}

@Component({
  selector: 'signgaze-card-view',
  templateUrl: './card-view.component.html',
  styleUrls: ['./card-view.component.scss'],
})
export class CardViewComponent implements OnInit {
  readonly subs = new SubSink();
  readonly alogliaConfig: any = {
    ...ALOGLIA_CONFIG,
  };
  readonly defaultSearchParameters = {
    hitsPerPage: 12,
    clickAnalytics: true,
  };

  StateTypeEnum: any = StateType;
  LoadingTypeEnum: any = LoadingType;
  pageStateEnum: any = PageState;
  toggleModalVisibility = false;
  pageState: PageState = this.pageStateEnum.LOADING;
  searchParameters: any = {
    ...this.defaultSearchParameters,
  };
  facetCategory: string;
  facetValue: string;
  isCheckedMap = false;
  isShowMap = false;
  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.buildSearchParameters();
    this.listingsInitialLoader();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  public listingsInitialLoader(): void {
    setTimeout(() => {
      this.pageState = PageState.LOADED;
    }, 500);
  }

  public isShowFilter(): void {
    this.toggleModalVisibility = !this.toggleModalVisibility;
  }

  private buildSearchParameters(): void {
    this.route.queryParams.subscribe((params) => {
      if (Object.keys(params)[0]) {
        this.facetCategory = Object.keys(params)[0];
        this.facetValue = decodeURI(Object.values(params)[0]);
        this.searchParameters = {
          ...this.searchParameters,
          facetFilters: [`${this.facetCategory}:${this.facetValue}`],
        };
      } else {
        this.facetCategory = null;
        this.facetValue = null;
        this.searchParameters = {
          ...this.defaultSearchParameters,
        };
      }
    });
  }
}
